import { gql } from "@apollo/client";export default gql`mutation deleteBook($id: Int!) {
    deleteBook: delete_group_by_pk(id: $id) {
        id
    }
}
`;
